<app-modal
  modalId="news"
  classes="!top-auto !bottom-0 !mt-0 !h-auto !max-h-[85%] !box-border !flex flex-col !rounded-t-[28px] !rounded-b-none mobile:!bottom-auto mobile:!rounded-lg mobile:!max-w-[560px] mobile:!w-[90%]"
  containerClasses="!h-auto min-h-0 flex-auto !overflow-y-auto overscroll-contain !px-3 !py-5 mobile:!p-6"
  [shouldSwipeDownToClose]="true"
>
  @if (news) {
  <app-news-content
    [news]="news"
    [active]="isNewsOpen() && !updates.mobileUpdate()"
    (dismissed)="closeNewsModal()"
  />
  }
</app-modal>
